import { render, staticRenderFns } from "./promoteLink.vue?vue&type=template&id=644ad246&"
import script from "./promoteLink.vue?vue&type=script&lang=js&"
export * from "./promoteLink.vue?vue&type=script&lang=js&"
import style0 from "./promoteLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports